import { ActionTypes } from "@/App/constants/actionTypes";
import { PricingLevel } from "@/types/appTypes/pricingLevels";

type GetPricingLevelAction = {
  type: typeof ActionTypes.GET_PRICING_LEVEL;
  payload: number;
};

export const getPricingLevel = (data: number): GetPricingLevelAction => {
  return {
    type: ActionTypes.GET_PRICING_LEVEL,
    payload: data,
  };
};

type GetPricingLevelResultsAction = {
  type: typeof ActionTypes.GET_PRICING_LEVEL_RESULTS;
  payload: PricingLevel;
};

export const getPricingLevelResults = (data: PricingLevel): GetPricingLevelResultsAction => {
  return {
    type: ActionTypes.GET_PRICING_LEVEL_RESULTS,
    payload: data,
  };
};

export type GetPricingLevelActions = GetPricingLevelAction | GetPricingLevelResultsAction;
